(() => {
  const instances = new Map();
  function init(root) {
    if (instances.has(root)) return;
    const viewport = root.querySelector('.aw-viewport');
    const slides = [...root.querySelectorAll('.aw-slide')];
    const dots = [...root.querySelectorAll('.aw-dot')];
    if (!viewport || !slides.length) return;
    const count = root.querySelector('[data-slide-count]');
    const status = root.querySelector('[data-slide-status]');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const controller = new AbortController();
    const {signal} = controller;
    let current = 0, timer, point = null, moved = false, visible = true, paused = false;
    // No nested scroll container: vertical touch scrolling belongs entirely to the page.
    Object.assign(viewport.style, {display:'block', overflow:'clip', scrollSnapType:'none', touchAction:'pan-y pinch-zoom'});
    slides.forEach((slide, i) => {
      Object.assign(slide.style, {position:'absolute', inset:'0', width:'100%', transform:`translate3d(${i === 0 ? 0 : 100}%,0,0)`, visibility:i === 0 ? 'visible' : 'hidden'});
      slide.querySelectorAll('img, a').forEach(el => {el.draggable = false; el.style.touchAction = 'pan-y pinch-zoom';});
    });
    const pause = document.createElement('button');
    pause.type = 'button'; pause.textContent = 'Ⅱ'; pause.setAttribute('aria-label','Pause slideshow');
    root.querySelector('.aw-arrows').prepend(pause);
    function schedule() {
      clearTimeout(timer);
      if (!paused && !reduced.matches && !document.hidden && visible && !point && slides.length > 1) timer = setTimeout(() => go(current + 1, 1, false), 2000);
    }
    function go(index, direction = index > current ? 1 : -1, announce = true) {
      const next = (index + slides.length) % slides.length;
      if (next !== current) {
        const old = current, incoming = slides[next], outgoing = slides[old];
        slides.forEach((slide, i) => {
          slide.style.transition = 'none';
          slide.style.visibility = i === old || i === next ? 'visible' : 'hidden';
        });
        incoming.style.transform = `translate3d(${direction * 100}%,0,0)`;
        void incoming.offsetWidth;
        const transition = reduced.matches ? 'none' : 'transform 380ms cubic-bezier(.22,.61,.36,1)';
        incoming.style.transition = outgoing.style.transition = transition;
        outgoing.style.transform = `translate3d(${-direction * 100}%,0,0)`;
        incoming.style.transform = 'translate3d(0,0,0)';
        current = next;
      }
      dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === current)));
      slides.forEach((slide, i) => {slide.querySelector('a').tabIndex = i === current ? 0 : -1; slide.setAttribute('aria-hidden',String(i !== current));});
      if (count) count.textContent = `${String(current + 1).padStart(2,'0')} / ${String(slides.length).padStart(2,'0')}`;
      if (status && announce) status.textContent = `Image ${current + 1} of ${slides.length}: ${slides[current].dataset.name}`;
      schedule();
    }
    pause.addEventListener('click', () => {paused = !paused; pause.textContent = paused ? '▶' : 'Ⅱ'; pause.setAttribute('aria-label',paused ? 'Play slideshow' : 'Pause slideshow'); schedule();}, {signal});
    dots.forEach((dot,i) => dot.addEventListener('click', () => go(i), {signal}));
    root.querySelector('[data-slide-prev]').addEventListener('click', () => go(current-1,-1), {signal});
    root.querySelector('[data-slide-next]').addEventListener('click', () => go(current+1,1), {signal});
    viewport.addEventListener('keydown', event => {
      if (!['ArrowRight','ArrowLeft','Home','End'].includes(event.key)) return;
      event.preventDefault();
      go(event.key === 'Home' ? 0 : event.key === 'End' ? slides.length-1 : current + (event.key === 'ArrowRight' ? 1 : -1));
    }, {signal});
    viewport.addEventListener('pointerdown', event => {
      if (!event.isPrimary || (event.pointerType === 'mouse' && event.button !== 0)) return;
      point = {x:event.clientX,y:event.clientY,id:event.pointerId,axis:null}; moved = false; clearTimeout(timer);
    }, {passive:true,signal});
    viewport.addEventListener('pointermove', event => {
      if (!point || event.pointerId !== point.id) return;
      const dx = Math.abs(event.clientX-point.x), dy = Math.abs(event.clientY-point.y);
      if (Math.max(dx,dy) > 8) moved = true;
      if (!point.axis && Math.max(dx,dy) > 10) point.axis = dx > dy*2 ? 'x' : 'y';
      // Never preventDefault or capture pointers: diagonal/vertical gestures scroll natively.
    }, {passive:true,signal});
    function release(event) {
      if (!point || event.pointerId !== point.id) return;
      const dx = event.clientX-point.x, dy = Math.abs(event.clientY-point.y), horizontal = point.axis === 'x';
      point = null;
      if (horizontal && Math.abs(dx) > 48 && Math.abs(dx) > dy*2) go(current+(dx<0?1:-1),dx<0?1:-1);
      else schedule();
    }
    window.addEventListener('pointerup',release,{passive:true,signal});
    window.addEventListener('pointercancel',() => {point = null; moved = true; schedule();},{passive:true,signal});
    viewport.addEventListener('click',event => {if(moved && event.detail) {event.preventDefault();event.stopPropagation();} moved=false;},{capture:true,signal});
    root.addEventListener('focusin',() => clearTimeout(timer),{signal});
    root.addEventListener('focusout',schedule,{signal});
    document.addEventListener('visibilitychange',schedule,{signal});
    reduced.addEventListener('change',schedule,{signal});
    const observer = new IntersectionObserver(entries => {visible = entries[0].isIntersecting; schedule();},{threshold:0.1});
    observer.observe(viewport);
    go(0,1,false);
    instances.set(root,() => {controller.abort();observer.disconnect();clearTimeout(timer);pause.remove();});
  }
  function mount(scope) {scope.querySelectorAll('[data-campaign-slider]').forEach(init);}
  mount(document);
  document.addEventListener('shopify:section:load',event => mount(event.target));
  document.addEventListener('shopify:section:unload',event => {instances.forEach((destroy,root) => {if(event.target.contains(root)) {destroy();instances.delete(root);}});});
})();
